// src/hooks/useNotification.js

import { useContext } from 'react';
import { NotificationContext } from '../context/NotificationContext';

export default function useNotification() {
  const context = useContext(NotificationContext);
  if (!context) {
    console.warn('⚠️ useNotification called outside NotificationProvider');
    return {
      showNotification: () => {},
      hideNotification: () => {},
      clearNotification: () => {},
      notification: null,
    };
  }
  return context;
}